import {
  CLASSROOM_PLAN,
  CONSULTATION_PLAN,
  CONSULTATION_PLAN_PREVIEW,
  DISCHARGE_SCREENING_REPORT,
  DISCHARGE_SUMMARY_REPORT,
  INDIVIDUAL_SESSION_REPORT,
  INDIVIDUAL_START_SESSION,
  SCHOOL_CLIENT_LIST,
  TREATMENT_PLAN,
  TREATMENT_SUMMARY_REPORT,
  TREATMENT_PLAN_START_SESSION,
  TREATMENT_PLAN_REPORT,
  TREATMENT_PLAN_REPORT_PREVIEW,
  INDIVIDUAL_MANAGE_GOALS,
  INDIVIDUAL_SESSION_REPORT_PREVIEW,
  TREATMENT_SUMMARY_REPORT_PREVIEW,
  ACCOUNT_VERIFICATION,
  FORGOT_PASSWORD,
  LOGIN,
  RESET_PASSWORD,
  CHATTER_EVENT,
  CHATTER_EVENT_DETAIL,
  CLASSROOM_SERVICES,
  MULTIDISCIPLINARY_SERVICES,
  MULTIDISCIPLINARY_SERVICES_DETAIL,
  CHATTER_LESSON_PLANS,
  CHATTER_LESSON_PLANS_ADD,
  CHATTER_EVENT_ATTENDANCE,
  MY_FAVOURITE_GOAL,
  SCHOOL_DISCHARGES,
  SHARED_LESSION_PLAN,
  MY_RESOURCES,
  MANAGE_GROUP,
  ADD_MANAGE_GROUP,
  MANAGE_GROUP_DETAIL,
  SCHOOL_DISCHARGE_DETAILS,
  ABOUT_US,
  TERMS_AND_CONDITIONS,
  ACCEPT_TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
  VIDEOS,
  SCHOOL_CLIENT_DETAIL,
  DISCHARGE_SUMMARY_REPORT_PREVIEW,
  DISCHARGE_SCREENING_REPORT_PREVIEW,
  HOME_EDUCATION_CLIENT_DETAIL,
  CHATTER_CLIENT_DETAIL,
  PRIVATE_CLIENT_LIST,
  PRIVATE_CLIENT_DETAIL,
  POLICY_AND_PROCEDURES,
  EDIT_MANAGE_GROUP,
  CHATTER_PROGRAM_CONSULTATION_REPORT,
  CHATTER_PROGRAM_CONSULTATION_REPORT_PREVIEW,
  CHATTER_EVENT_ATTENDANCE_DETAIL,
  CHATTER_LESSON_PLANS_EDIT,
  CLASSROOM_SERVICES_ADD,
  CLASSROOM_SERVICES_EDIT,
  CLASSROOM_PLAN_PREVIEW,
  CHATTER_CLIENT_LIST,
  MANAGE_STAFF,
  MANAGE_STAFF_ADD,
  MANAGE_STAFF_CLIENT_LIST,
  MANAGE_STAFF_TASK_LIST,
  PROFILE,
  VIEW_REPORT,
  MANAGE_TEAM,
  MANAGE_PARENT,
  MANAGE_PARENT_ADD,
  MANAGE_PARENT_CLIENT_LIST,
  MANAGE_PARENT_TASK_LIST,
  MANAGE_APPOINTMENT_LIST,
  MANAGE_PARENT_TASK_VIEW,
  MANAGE_PARENT_SESSION_VIEW,
  MANAGE_PARENT_TASK_DETAILS,
  MANAGE_STAFF_TASK_DETAILS,
  MANAGE_STAFF_SESSION_VIEW,
  MANAGE_APPOINTMENT_FORM,
  MANAGE_STAFF_GROUP_TASK_LIST,
  MANAGE_STAFF_GROUP_SESSION_VIEW,
  STAFF_TASKS_TEMPLATES,
  STAFF_TASKS_TEMPLATES_ADD,
  STAFF_TASKS_TEMPLATES_EDIT,
  VIEW_CONSENT_FORM,
  SCHOOL_DISCHARGE_SCREENING_REPORT,
  SCHOOL_INDIVIDUAL_SESSION_REPORT,
  SCHOOL_CONSULTATION_REPORT,
  SCHOOL_ASSESSMENT_REPORT,
  SCHOOL_CLASSROOM_PLAN,
  CHATTER_CONSULTATION_REPORT,
  COMPONENT_TEMPLATES,
  RECOMMENDATIONS_TEMPLATES,
  STRATEGIES_TEMPLATES,
  DOCUMENT_PDF_VIEW,
  HOME_INDIVIDUAL_SESSION_REPORT,
  PRIVATE_INDIVIDUAL_SESSION_REPORT,
  CLASSROOM_REPORTS,
  EDIT_SCHOOL_CLASSROOM_PLAN,
  HOME_ASSESSMENT_REPORT,
  PRIVATE_ASSESSMENT_REPORT,
  HOME_CONSULTATION_REPORT,
  PRIVATE_CONSULTATION_REPORT,
  NOTES_TABLE,
  CREATE_NOTES,
  EDIT_NOTES,
  DIAGNOSIS_SERVERITY,
  SERVICE_STATUS_LIST,
  CLIENT_ATTENDANCE_LIST,
  CLIENT_DOCUMENTS_LIST,
  MDT_CLIENT_DOCUMENTS_LIST,
  CLIENT_REPORTS_LIST,
  WORKSHOPS,
  WORKSHOP_ADD,
  WORKSHOP_EDIT,
  WORKSHOP_VIEW,
  CLINICIANS_HISTORY,
  ONBOARD,
  PROFILE_SLUG,
  CHATTER_CLIENT_ATTENDANCE,
  SUPPORT_STAFF,
  SUPPORT_STAFF_DETAIL,
  SUPPORT_STAFF_ADD,
  SUPPORT_STAFF_EDIT,
  SUPPORT_STAFF_TASK,
  TASK_PLAN_TEMPLATES,
  TASK_PLAN_TEMPLATES_ADD,
  TASK_PLAN_TEMPLATES_EDIT,
  TASK_PLAN,
  TASK_PLAN_ADD,
  TASK_PLAN_EDIT,
  SUPPORT_STAFF_CLIENT,
  TASK_PLAN_VIEW,
  SCHOOL_TREATMENT_REPORT,
  CHANGE_PASSWORD,
  NOTIFICATIONS,
  MY_POLICIES,
} from "config/paths";

import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import ClientChatter from "./SideTabPages/Clients/Chatter";
import AddClientChatter from "./SideTabPages/Clients/Chatter/Add";
import HomeEducation from "./SideTabPages/Clients/HomeEducation";
import AddClientHome from "./SideTabPages/Clients/HomeEducation/Add";
import IndividualSessionReport from "./SideTabPages/Clients/ReportCollection/IndividualSessionReport";
import ClientPrivate from "./SideTabPages/Clients/Private";
import AddClientPrivate from "./SideTabPages/Clients/Private/Add";
import ClientSchool from "./SideTabPages/Clients/School";
import ClientTreatmentPlan from "./SideTabPages/Clients/ReportCollection/TreatmentPlan/Goals";
import ClientTreatmentPlanReport from "./SideTabPages/Clients/ReportCollection/TreatmentPlan/Report";
import ClientTreatmentPlanReportPreview from "./SideTabPages/Clients/ReportCollection/TreatmentPlan/Report/Preview";
import ClientStartSession from "./SideTabPages/Clients/ReportCollection/TreatmentPlan/StartSession";
import TreatmentSummaryReport from "./SideTabPages/Clients/ReportCollection/TreatmentSummaryReport";
import TreatmentSummaryReportPreview from "./SideTabPages/Clients/ReportCollection/TreatmentSummaryReport/Preview";
import DischargeSummaryReport from "./SideTabPages/Clients/ReportCollection/DischargeSummaryReport";
import DischargeSummaryReportPreview from "./SideTabPages/Clients/ReportCollection/DischargeSummaryReport/Preview";
import ClassroomPlan from "./SideTabPages/Clients/ReportCollection/ClassroomPlan";
import ConsultationPlan from "./SideTabPages/Clients/ReportCollection/ConsultationPlan";
import DischargeScreeningReport from "./SideTabPages/Clients/ReportCollection/DischargeScreeningReport";
import DischargeScreeningReportPreview from "./SideTabPages/Clients/ReportCollection/DischargeScreeningReport/Preview/Index";
import ClientIndividualStartSession from "./SideTabPages/Clients/ReportCollection/IndividualSessionReport/StartSession";
import ClassroomPlanPreview from "./SideTabPages/Clients/ReportCollection/ClassroomPlan/Preview";
import ClientIndividualGoals from "./SideTabPages/Clients/ReportCollection/IndividualSessionReport/Goals";
import IndividualSessionReportPreview from "./SideTabPages/Clients/ReportCollection/IndividualSessionReport/Preview";
import ActivateAccount from "./AuthPages/ActivateAccount/Index";
import ChatterEvent from "./SideTabPages/ChatterEvent";
import ChatterEventDetail from "./SideTabPages/ChatterEvent/detail";
import Multidisciplinary from "./SideTabPages/Multidisciplinary";
import MultidisciplinaryDetail from "./SideTabPages/Multidisciplinary/detail";
import ChatterLessonPlan from "./SideTabPages/LessonPlan";
import ChatterLessonPlanAdd from "./SideTabPages/LessonPlan/Add";
import ChatterEventAttendance from "./SideTabPages/ChatterEventAttendance";
import MyFavouriteGoal from "./MyFavouriteGoal";
import SharedLessionPlan from "./SideTabPages/Clients/SharedLessionPlans";
import SchoolDischarges from "./SideTabPages/Clients/SchoolDischarges";
import MyResources from "./SideTabPages/Clients/MyResources";
import ManageGroup from "./SideTabPages/Clients/ManageGroup";
import AddNewGroup from "./SideTabPages/Clients/ManageGroup/Add";
import GroupDetail from "./SideTabPages/Clients/ManageGroup/GroupDetails";
import SchoolDischargesDetail from "./SideTabPages/Clients/SchoolDischarges/detail";
import AboutUs from "./SideTabPages/OtherUsefulLinks/AboutUs";
import TermsAndConditions from "./SideTabPages/OtherUsefulLinks/TermsAndConditions";
import AcceptTerms from "./AcceptTerms/Index";
import PrivacyPolicy from "./SideTabPages/OtherUsefulLinks/PrivacyPolicy";
import Videos from "./SideTabPages/OtherUsefulLinks/Videos";
import ClientSchoolDetail from "./SideTabPages/Clients/School/detail";
import ConsultationPlanPreview from "./SideTabPages/Clients/ReportCollection/ConsultationPlan/Preview";
import ClassRoom from "./ClassRoom";
import ClientHomeDetail from "./SideTabPages/Clients/HomeEducation/Detail";
import ClientChatterDetail from "./SideTabPages/Clients/Chatter/detail";
import ClientPrivateDetail from "./SideTabPages/Clients/Private/detail";
import PolicyAndProcedures from "./SideTabPages/PolicyAndProcedures";
import ChatterProgramConsultationReport from "./SideTabPages/Clients/ReportCollection/ChatterProgramConsultationReport";
import ChatterProgramConsultationPreview from "./SideTabPages/Clients/ReportCollection/ChatterProgramConsultationReport/Preview";
import ChatterEventAttendanceDetail from "./SideTabPages/ChatterEventAttendance/detail";
import AddClassRoomConsultation from "./ClassRoom/Add";
import ManageStaff from "./SideTabPages/ManageStaff";
import AddStaff from "./SideTabPages/ManageStaff/Add/Index";
import StaffClients from "./SideTabPages/ManageStaff/Clients/index";
import StaffTasks from "./SideTabPages/ManageStaff/Tasks";
import Profile from "./SideTabPages/Profile";
import Onboard from "./SideTabPages/Onboard"
import ViewReport from "./SideTabPages/Clients/ViewReport/Index";
import ManageTeam from "./SideTabPages/ManageTeam";
import ManageParent from "./SideTabPages/ManageParent";
import AddParentTask from "./SideTabPages/ManageParent/Add/Index";
import ParentClients from "./SideTabPages/ManageParent/Clients";
import ParentTasks from "./SideTabPages/ManageParent/Tasks";
import ManageAppointment from "./SideTabPages/Appointment";
import ParentTasksView from "./SideTabPages/ManageParent/Taskview";
import ParentTasksSession from "./SideTabPages/ManageParent/StartSession/StartSession";
import StaffTasksSession from "./SideTabPages/ManageStaff/StartSession/StartSessionStaff";
import { components } from "react-select";
import CompleteFormsFill from "./SideTabPages/ConsentFormView/CompleteFormsFill";
import GroupStartSession from "./SideTabPages/ManageParent/Tasks/GroupStartSession";
import GroupStartSessionStaff from "./SideTabPages/ManageStaff/Tasks/GroupStartSessionStaff";
import ManageAppointmentForm from "./SideTabPages/Appointment/ManageAppointmentForm";
import GroupTasks from "./SideTabPages/ManageStaff/GroupTasks";
import GroupTaskSession from "./SideTabPages/ManageStaff/GroupTasks/GroupTasksSession";
import ManageStaffTasksTemplates from "./SideTabPages/StaffTaskTemplates";
import AddStaffTaskTemplate from "./SideTabPages/StaffTaskTemplates/Add";
import ViewConsentForm from "./SideTabPages/Clients/ViewConsentForm";
import SchoolDischargeScreeningReport from "./SideTabPages/Clients/School/reports/DischargeScreeningReport";
import SchoolIndividualSessionReport from "./SideTabPages/Clients/School/reports/IndivdualSessionReport";
import SchoolConsultationReport from "./SideTabPages/Clients/School/reports/ConsultationReport";
import SchoolAssessmentReport from "./SideTabPages/Clients/School/reports/AssessmentReport";
import ClassroomConsultationReport from "./SideTabPages/Clients/School/reports/ClassroomConsultationReport";
import ChatterConsultationReport from "./SideTabPages/Clients/Chatter/reports/ChatterConsultationReport";
import ComponentTemplates from "./SideTabPages/MyLibrary/ComponentTemplates";
import RecommendationsTemplates from "./SideTabPages/MyLibrary/ComponentTemplates/Recommendations";
import StrategiesTemplates from "./SideTabPages/MyLibrary/ComponentTemplates/Strategies";
import { PdfViewPage } from "components/shared/PdfViewPage/PdfViewPage";
import HomeIndividualSessionReport from "./SideTabPages/Clients/HomeEducation/Reports/IndivdualSessionReport";
import PrivateIndividualSessionReport from "./SideTabPages/Clients/Private/Reports/IndivdualSessionReport";
import ClassRoomReports from "./ClassroomReport";
import ClassroomReport from "./ClassroomReport/Add";
import HomeAssessmentReport from "./SideTabPages/Clients/HomeEducation/Reports/AssessmentReport";
import PrivateAssessmentReport from "./SideTabPages/Clients/Private/Reports/AssessmentReport";
import HomeConsultationReport from "./SideTabPages/Clients/HomeEducation/Reports/ConsultationReport";
import PrivateConsultationReport from "./SideTabPages/Clients/Private/Reports/ConsultationReport";
import NotesComponent from "components/shared/FormComponents/V2/Notes/NotesComponent";
import NotesTable from "components/shared/FormComponents/V2/Notes/NotesTable";
import AddNotesForm from "components/shared/FormComponents/V2/Notes/Add";
import DiagnosisPage from "components/shared/FormComponents/V2/Diagnosis/DiagnosisPage";
import ServiceStatusPage from "components/shared/FormComponents/V2/CliniciansAssigned/ServiceStatusPage";
import AttendanceTracker from "components/shared/FormComponents/V2/Attendance/AttendanceTrack";
import ClientAttachmentsPage from "components/shared/FormComponents/V2/ClientAttachments/ClientAttachmentsPage";
import ReportsPage from "components/shared/FormComponents/V2/ReportsComponent/ReportsPage";
import Workshops from "./SideTabPages/Workshop";
import AddWorkshop from "./SideTabPages/Workshop/Add";
import WorkshopView from "./SideTabPages/Workshop/View";
import CliniciansHistory from "components/shared/FormComponents/V2/CliniciansAssigned/CliniciansHistory";
import ChatterAttendanceTracker from "components/shared/FormComponents/V2/ChatterAttendance/ChatterAttendanceTrack";
import ProfileInformation from "./SideTabPages/Profile/[slug]";
import TaskPlanTemplates from "./SideTabPages/MyLibrary/ComponentTemplates/TaskPlanTemplate";
import TaskPlanTemplateAdd from "./SideTabPages/MyLibrary/ComponentTemplates/TaskPlanTemplate/add";
import TaskPlan from "./SideTabPages/Clients/TaskPlan";
import AddTaskPlan from "./SideTabPages/Clients/TaskPlan/Add";
import EditTaskPlan from "./SideTabPages/Clients/TaskPlan/Edit";
import SupportStaff from "./SideTabPages/Clients/SupportStaff";
import SupportStaffAdd from "./SideTabPages/Clients/SupportStaff/add";
import SupportStaffTask from "./SideTabPages/Clients/SupportStaff/task";
import SuppportStaffDetail from "./SideTabPages/Clients/SupportStaff/detail";
import SupportStaffTaskClient from "./SideTabPages/Clients/SupportStaff/client";
import TreatmentSummaryReportV2 from "./SideTabPages/Clients/School/reports/TreatmentSummaryReport";
import ChangePassword from "components/shared/ProfileV2/ChangePassword";
import Notifications from "./SideTabPages/Notifications";
import MyPolicies from "components/shared/ProfileV2/MyPolicies";

export const routes = [
  { path: LOGIN, component: <Login /> },
  { path: FORGOT_PASSWORD, component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: RESET_PASSWORD, component: <ResetPassword /> },
  { path: ACCOUNT_VERIFICATION, component: <ActivateAccount /> },
];

export const privateRoutes = [
  { path: SCHOOL_CLIENT_LIST, component: <ClientSchool /> },
  { path: SCHOOL_CLIENT_DETAIL, component: <ClientSchoolDetail /> },
  { path: TREATMENT_PLAN, component: <ClientTreatmentPlan /> },
  {
    path: NOTIFICATIONS,
    component: <Notifications />,
  },
  {
    path: TREATMENT_PLAN_START_SESSION,
    component: <ClientStartSession />,
  },
  {
    path: TREATMENT_PLAN_REPORT,
    component: <ClientTreatmentPlanReport />,
  },
  {
    path: TREATMENT_PLAN_REPORT_PREVIEW,
    component: <ClientTreatmentPlanReportPreview />,
  },
  {
    path: INDIVIDUAL_MANAGE_GOALS,
    component: <ClientIndividualGoals />,
  },
  {
    path: INDIVIDUAL_START_SESSION,
    component: <ClientIndividualStartSession />,
  },
  {
    path: INDIVIDUAL_SESSION_REPORT,
    component: <IndividualSessionReport />,
  },
  {
    path: INDIVIDUAL_SESSION_REPORT_PREVIEW,
    component: <IndividualSessionReportPreview />,
  },
  {
    path: TREATMENT_SUMMARY_REPORT,
    component: <TreatmentSummaryReport />,
  },
  {
    path: TREATMENT_SUMMARY_REPORT_PREVIEW,
    component: <TreatmentSummaryReportPreview />,
  },
  {
    path: DISCHARGE_SUMMARY_REPORT,
    component: <DischargeSummaryReport />,
  },
  {
    path: DISCHARGE_SUMMARY_REPORT_PREVIEW,
    component: <DischargeSummaryReportPreview />,
  },
  {
    path: CLASSROOM_PLAN,
    component: <ClassroomPlan />,
  },
  {
    path: CLASSROOM_PLAN_PREVIEW,
    component: <ClassroomPlanPreview />,
  },
  {
    path: CLASSROOM_REPORTS,
    component: <ClassRoomReports />,
  },
  {
    path: SUPPORT_STAFF,
    component: <SupportStaff />,
  },
  {
    path: SUPPORT_STAFF_ADD,
    component: <SupportStaffAdd />,
  },
  {
    path: SUPPORT_STAFF_EDIT,
    component: <SupportStaffAdd />,
  },
  {
    path: SUPPORT_STAFF_TASK,
    component: <SupportStaffTask />
  },
  {
    path: SUPPORT_STAFF_DETAIL,
    component: <SuppportStaffDetail />
  },
  {
    path: SUPPORT_STAFF_CLIENT,
    component: <SupportStaffTaskClient />
  },
  {
    path: CONSULTATION_PLAN,
    component: <ConsultationPlan />,
  },
  {
    path: CONSULTATION_PLAN_PREVIEW,
    component: <ConsultationPlanPreview />,
  },
  {
    path: DISCHARGE_SCREENING_REPORT,
    component: <DischargeScreeningReport />,
  },
  {
    path: DISCHARGE_SCREENING_REPORT_PREVIEW,
    component: <DischargeScreeningReportPreview />,
  },
  {
    path: CHATTER_PROGRAM_CONSULTATION_REPORT,
    component: <ChatterProgramConsultationReport />,
  },
  {
    path: CHATTER_PROGRAM_CONSULTATION_REPORT_PREVIEW,
    component: <ChatterProgramConsultationPreview />,
  },
  {
    path: CHATTER_EVENT,
    component: <ChatterEvent />,
  },
  {
    path: CHATTER_EVENT_DETAIL,
    component: <ChatterEventDetail />,
  },
  {
    path: MULTIDISCIPLINARY_SERVICES,
    component: <Multidisciplinary />,
  },
  {
    path: CLASSROOM_SERVICES,
    component: <ClassRoom />,
  },
  {
    path: CLASSROOM_SERVICES_ADD,
    component: <AddClassRoomConsultation />,
  },
  {
    path: CLASSROOM_SERVICES_EDIT,
    component: <AddClassRoomConsultation />,
  },
  {
    path: MULTIDISCIPLINARY_SERVICES_DETAIL,
    component: <MultidisciplinaryDetail />,
  },
  {
    path: CHATTER_LESSON_PLANS,
    component: <ChatterLessonPlan />,
  },
  {
    path: DOCUMENT_PDF_VIEW,
    component: <PdfViewPage />,
  },
  {
    path: CHATTER_LESSON_PLANS_ADD,
    component: <ChatterLessonPlanAdd />,
  },
  {
    path: CHATTER_LESSON_PLANS_EDIT,
    component: <ChatterLessonPlanAdd />,
  },
  {
    path: CHATTER_EVENT_ATTENDANCE,
    component: <ChatterEventAttendance />,
  },
  {
    path: CHATTER_EVENT_ATTENDANCE_DETAIL,
    component: <ChatterEventAttendanceDetail />,
  },
  {
    path: MY_FAVOURITE_GOAL,
    component: <MyFavouriteGoal />,
  },
  {
    path: SHARED_LESSION_PLAN,
    component: <SharedLessionPlan />,
  },
  {
    path: SCHOOL_DISCHARGES,
    component: <SchoolDischarges />,
  },
  {
    path: SCHOOL_DISCHARGE_DETAILS,
    component: <SchoolDischargesDetail />,
  },
  {
    path: MY_RESOURCES,
    component: <MyResources />,
  },
  {
    path: MANAGE_GROUP,
    component: <ManageGroup />,
  },
  {
    path: ADD_MANAGE_GROUP,
    component: <AddNewGroup />,
  },
  {
    path: EDIT_MANAGE_GROUP,
    component: <AddNewGroup />,
  },
  {
    path: MANAGE_GROUP_DETAIL,
    component: <GroupDetail />,
  },

  { path: "/client/home-education", component: <HomeEducation /> },
  { path: "/client/home-education/add", component: <AddClientHome /> },
  { path: HOME_EDUCATION_CLIENT_DETAIL, component: <ClientHomeDetail /> },

  { path: CHATTER_CLIENT_LIST, component: <ClientChatter /> },
  { path: "/client/chatter/add", component: <AddClientChatter /> },
  { path: CHATTER_CLIENT_DETAIL, component: <ClientChatterDetail /> },
  { path: CHATTER_CLIENT_ATTENDANCE, component: <ChatterAttendanceTracker /> },

  { path: PRIVATE_CLIENT_LIST, component: <ClientPrivate /> },
  { path: "/client/private/add", component: <AddClientPrivate /> },
  { path: PRIVATE_CLIENT_DETAIL, component: <ClientPrivateDetail /> },

  {
    path: ABOUT_US,
    component: <AboutUs />,
  },
  {
    path: TERMS_AND_CONDITIONS,
    component: <TermsAndConditions />,
  },
  {
    path: ACCEPT_TERMS_AND_CONDITIONS,
    component: <AcceptTerms />,
  },
  {
    path: PRIVACY_POLICY,
    component: <PrivacyPolicy />,
  },
  {
    path: VIDEOS,
    component: <Videos />,
  },
  {
    path: POLICY_AND_PROCEDURES,
    component: <PolicyAndProcedures />,
  },
  {
    path: MANAGE_STAFF,
    component: <ManageStaff />,
  },
  {
    path: MANAGE_STAFF_ADD,
    component: <AddStaff />
  },
  {
    path: MANAGE_STAFF_CLIENT_LIST,
    component: <StaffClients />
  },
  {
    path: MANAGE_STAFF_TASK_LIST,
    component: <StaffTasks />
  },
  {
    path: MANAGE_STAFF_GROUP_TASK_LIST,
    component: <GroupTasks />
  },
  {
    path: PROFILE,
    component: <Profile />
  },
  {
    path: MY_POLICIES,
    component: <MyPolicies />,
  },
  {
    path: CHANGE_PASSWORD,
    component: <ChangePassword />
  },
  {
    path: PROFILE_SLUG,
    component: <ProfileInformation />
  },
  {
    path: VIEW_REPORT,
    component: <ViewReport />
  },
  {
    path: MANAGE_TEAM,
    component: <ManageTeam />
  },
  {
    path: MANAGE_PARENT,
    component: <ManageParent />,
  },
  {
    path: MANAGE_PARENT_ADD,
    component: <AddParentTask />,
  },
  {
    path: MANAGE_PARENT_CLIENT_LIST,
    component: <ParentClients />
  },
  {
    path: MANAGE_PARENT_TASK_LIST,
    component: <ParentTasks />
  },
  {
    path: MANAGE_PARENT_TASK_VIEW,
    component: <ParentTasksView />
  },
  {
    path: MANAGE_PARENT_SESSION_VIEW,
    component: <ParentTasksSession />
  },
  {
    path: MANAGE_STAFF_SESSION_VIEW,
    component: <StaffTasksSession />
  },
  // {
  //   path: MANAGE_APPOINTMENT_LIST,
  //   component: <ManageAppointment />
  // },
  // {
  //   path: MANAGE_APPOINTMENT_FORM,
  //   component: <ManageAppointmentForm />
  // },
  {
    path: '/complete-forms/:parent_id/:consent_id',
    component: <CompleteFormsFill />
  },
  {
    path: MANAGE_PARENT_TASK_DETAILS,
    component: <GroupStartSession />
  },
  {
    path: MANAGE_STAFF_TASK_DETAILS,
    component: <GroupStartSessionStaff />
  },
  {
    path: MANAGE_STAFF_GROUP_SESSION_VIEW,
    component: <GroupTaskSession />
  },
  {
    path: STAFF_TASKS_TEMPLATES,
    component: <ManageStaffTasksTemplates />
  },
  {
    path: STAFF_TASKS_TEMPLATES_ADD,
    component: <AddStaffTaskTemplate />
  },
  {
    path: STAFF_TASKS_TEMPLATES_EDIT,
    component: <AddStaffTaskTemplate />
  },
  {
    path: VIEW_CONSENT_FORM,
    component: <ViewConsentForm />
  },

  // SCHOOL V2 REPORTS 
  {
    path: SCHOOL_DISCHARGE_SCREENING_REPORT,
    component: <SchoolDischargeScreeningReport />,
  },
  {
    path: SCHOOL_INDIVIDUAL_SESSION_REPORT,
    component: <SchoolIndividualSessionReport />,
  },
  {
    path: SCHOOL_CONSULTATION_REPORT,
    component: <SchoolConsultationReport />,
  },
  {
    path: SCHOOL_ASSESSMENT_REPORT,
    component: <SchoolAssessmentReport />,
  },
  {
    path: SCHOOL_TREATMENT_REPORT,
    component: <TreatmentSummaryReportV2 />,
  },
  {
    path: SCHOOL_CLASSROOM_PLAN,
    component: <ClassroomReport />,
  },
  {
    path: EDIT_SCHOOL_CLASSROOM_PLAN,
    component: <ClassroomReport />,
  },

  // CHATTER V2 REPORTS
  {
    path: CHATTER_CONSULTATION_REPORT,
    component: <ChatterConsultationReport />,
  },
  {
    path: COMPONENT_TEMPLATES,
    component: <ComponentTemplates />
  },
  {
    path: RECOMMENDATIONS_TEMPLATES,
    component: <RecommendationsTemplates />
  },
  {
    path: TASK_PLAN_TEMPLATES,
    component: <TaskPlanTemplates />
  },
  {
    path: TASK_PLAN_TEMPLATES_ADD,
    component: <TaskPlanTemplateAdd />
  },
  {
    path: TASK_PLAN_TEMPLATES_EDIT,
    component: <TaskPlanTemplateAdd />
  },
  {
    path: TASK_PLAN,
    component: <TaskPlan />
  },

  {
    path: TASK_PLAN_ADD,
    component: <AddTaskPlan />
  },
  {
    path: TASK_PLAN_EDIT,
    component: <EditTaskPlan />
  },
  {
    path: TASK_PLAN_VIEW,
    component: <SupportStaffTaskClient />
  },
  {
    path: STRATEGIES_TEMPLATES,
    component: <StrategiesTemplates />
  },
  // HOME EDUCATION V2 REPORTS
  {
    path: HOME_INDIVIDUAL_SESSION_REPORT,
    component: <HomeIndividualSessionReport />,
  },
  {
    path: HOME_ASSESSMENT_REPORT,
    component: <HomeAssessmentReport />
  },
  {
    path: HOME_CONSULTATION_REPORT,
    component: <HomeConsultationReport />
  },
  // PRIVATE V2 REPORTS
  {
    path: PRIVATE_INDIVIDUAL_SESSION_REPORT,
    component: <PrivateIndividualSessionReport />,
  },
  {
    path: PRIVATE_ASSESSMENT_REPORT,
    component: <PrivateAssessmentReport />
  },
  {
    path: PRIVATE_CONSULTATION_REPORT,
    component: <PrivateConsultationReport />
  },
  // NOTES
  {
    path: NOTES_TABLE,
    component: <NotesTable />
  },
  {
    path: CREATE_NOTES,
    component: <AddNotesForm />
  },
  {
    path: EDIT_NOTES,
    component: <AddNotesForm />
  },
  // DIAGNOSIS AND SEVERITY
  {
    path: DIAGNOSIS_SERVERITY,
    component: <DiagnosisPage />
  },
  // SERVICE STATUS 
  {
    path: SERVICE_STATUS_LIST,
    component: <ServiceStatusPage />
  },
  {
    path: CLINICIANS_HISTORY,
    component: <CliniciansHistory />
  },
  // ATTENDANCE TRACK 
  {
    path: CLIENT_ATTENDANCE_LIST,
    component: <AttendanceTracker />
  },
  // CLIENT DOCUMENTS 
  {
    path: CLIENT_DOCUMENTS_LIST,
    component: <ClientAttachmentsPage />
  },
  {
    path: MDT_CLIENT_DOCUMENTS_LIST,
    component: <ClientAttachmentsPage isMdtClient />
  },
  {
    path: CLIENT_REPORTS_LIST,
    component: <ReportsPage />
  },
  {
    path: WORKSHOPS,
    component: <Workshops />
  },
  {
    path: WORKSHOP_ADD,
    component: <AddWorkshop />
  },
  {
    path: WORKSHOP_EDIT,
    component: <AddWorkshop />
  },
  {
    path: WORKSHOP_VIEW,
    component: <WorkshopView />
  }
];
